import React from 'react';
import PropTypes from 'prop-types';
import {
  Link,
  withRouter,
} from 'react-router-dom';
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import { getCurrentURLParams } from '../../../helpers/URLParams';
import { getBackButtonMeta } from '../../../helpers/App';

import EmptyTableCell from '../../EmptyTableCell';

const AdminGroupsListItem = ({
  group,
  handleDelete,
  location,
}) => {
  const intl = useIntl();

  const linkTo = {
    pathname: `/admin/settings/teams/${group.uuid}/edit`,
    state: {
      goBackToListButton: {
        ...getBackButtonMeta('teams'),
        search: getCurrentURLParams(location),
      },
    },
  };

  return (
    <tr>
      <th scope="row" className="group-name">
        <div className="user-avatar group-avatar">
          <div className="avatar avatar-40 icon-avatar gray">
            <i className="fas fa-users-class" />
          </div>
        </div>
        <Link to={linkTo}>
          {group.name}
        </Link>
      </th>
      <td className="group-description">
        {group.description && group.description.length > 0 ? group.description : <EmptyTableCell />}
      </td>
      <td className="group-members">
        {group.members}
      </td>
      <td className="action-more">
        <UncontrolledDropdown>
          <DropdownToggle nav className="options">
            <i className="far fa-ellipsis-h" />
          </DropdownToggle>
          <DropdownMenu right>
            <Link to={linkTo} className="dropdown-item-link">
              <DropdownItem tag="span">
                <i className="fas fa-pencil" />
                {intl.formatMessage({ defaultMessage: 'Edit' })}
              </DropdownItem>
            </Link>
            <DropdownItem divider />
            <DropdownItem onClick={() => { handleDelete(group); }}>
              <i className="fas fa-trash" />
              {intl.formatMessage({ defaultMessage: 'Delete' })}
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      </td>
    </tr>
  );
};

AdminGroupsListItem.propTypes = {
  group: PropTypes.object.isRequired,
  handleDelete: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
};

export default withRouter(AdminGroupsListItem);
